import React from "react";

const Home = () => {
  return (
    <div className="container mt-5">
      <div className="card text-center" style={{ padding: "20px" }}>
        <h2>Welcome to My AI Application</h2>
        <p>
          Experience the power of AI with our demo application, designed to
          showcase cutting-edge technology in action.
        </p>
        <h4>How to Use This Demo</h4>
        <ul className="text-start d-inline-block">
          <li>To access the features, you must <strong>register</strong> and <strong>log in</strong>.</li>
          <li>Each session lasts <strong>30 seconds</strong>, after which you will need to log in again.</li>
          <li>This application integrates with a <strong>premium API</strong> that is not free.</li>
          <li>The app is strictly for <strong>demo purposes</strong> only.</li>
        </ul>
        <p>Enjoy exploring AI technology, and feel free to try out its features before the session expires!</p>
      </div>
    </div>
  );
};

export default Home;
